<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M7.332 16c3.722 0 6.77-3.032 6.77-6.77V8.05a.87.87 0 0 0-.876-.875.87.87 0 0 0-.875.876v1.178c-.034 2.763-2.274 5.003-5.02 5.003-2.744 0-5.001-2.24-5.001-5.003a4.988 4.988 0 0 1 5.002-4.985h1.044v1.6c0 .32.168.607.438.758a.9.9 0 0 0 .876 0L14 4.126a.884.884 0 0 0 .438-.758.864.864 0 0 0-.438-.757L9.69.118A.816.816 0 0 0 9.252 0a.816.816 0 0 0-.438.118.884.884 0 0 0-.438.758v1.6H7.332C3.609 2.476.56 5.507.56 9.246c0 3.74 3.032 6.754 6.77 6.754Z"
    />
  </svg>
</template>
